import { useCallback, useEffect, useState } from 'react';
import { listSubcategories } from '@/modules/inventory/services';
import type { Subcategory } from '@/modules/inventory/types';

export function useSubcategories(categoryId?: string) {
  const [subcategories, setSubcategories] = useState<Subcategory[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setSubcategories(await listSubcategories(undefined, categoryId));
    } catch {
      setError('No se pudieron cargar las subcategorías.');
    } finally {
      setLoading(false);
    }
  }, [categoryId]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { subcategories, loading, error, refresh };
}
